import { FC } from 'react';

import type { OrdersBasketProps } from './OrdersBasket.connect';
import { connectOrdersBasket } from './OrdersBasket.connect';
import { OrdersBasketWorkspaceNext } from './OrdersBasketWorkspaceNext';

export const OrdersBasketComponent: FC<OrdersBasketProps> = ({ isVisible }) => {
  return (
    <div className="page-container h-100 w-100 bg-lvl3" style={{ zIndex: 100 }} data-e2e="orders-basket-container">
      <OrdersBasketWorkspaceNext isVisible={isVisible} />
    </div>
  );
};

export const OrdersBasket = connectOrdersBasket(OrdersBasketComponent);
